import { defineMessages } from 'react-intl';

export default defineMessages({
  selectItemsLabel: {
    id: 'sku.modifiers.item-picker.select-items-label',
    defaultMessage: 'Select items',
  },
  itemsLabel: {
    id: 'sku.modifiers.item-picker.items-label',
    defaultMessage: 'Items',
  },
  searchPlaceholder: {
    id: 'sku.modifiers.item-picker.search-placeholder',
    defaultMessage: 'Select items',
  },
  itemsRequired: {
    id: 'sku.modifiers.item-picker.items-required',
    defaultMessage: 'This field is required',
  },
  selectAll: {
    id: 'sku.modifiers.item-picker.select-all',
    defaultMessage: 'Select all ({count})',
  },
  usedInItems: {
    id: 'sku.modifiers.item-picker.used-in-items',
    defaultMessage: 'Used in {count, plural, one {# item} other {# items}}',
  },
  noItemsSelected: {
    id: 'sku.modifiers.item-picker.no-items-selected',
    defaultMessage: 'No items yet',
  },
  removeSelection: {
    id: 'sku.modifiers.item-picker.remove-selection',
    defaultMessage: 'Remove',
  },
  reviewMenuAriaLabel: {
    id: 'sku.modifiers.item-picker.review-menu-aria-label',
    defaultMessage: 'Review items in {name}',
  },
  removeAllSelection: {
    id: 'sku.modifiers.item-picker.remove-all-selection',
    defaultMessage: 'Remove all',
  },
  removeAllAriaLabel: {
    id: 'sku.modifiers.item-picker.remove-all-aria-label',
    defaultMessage: 'Remove all items in {name}',
  },
  removeItemAriaLabel: {
    id: 'sku.modifiers.item-picker.remove-item-aria-label',
    defaultMessage: 'Remove {name}',
  },
  reviewMenuDialogLabel: {
    id: 'sku.modifiers.item-picker.review-menu-dialog-label',
    defaultMessage: 'Items in {name}',
  },
  reviewMenuClose: {
    id: 'sku.modifiers.item-picker.review-menu-close',
    defaultMessage: 'Close',
  },
  reviewMenuCancel: {
    id: 'sku.modifiers.item-picker.review-menu-cancel',
    defaultMessage: 'Cancel',
  },
  reviewMenuSave: {
    id: 'sku.modifiers.item-picker.review-menu-save',
    defaultMessage: 'Save',
  },
  noItems: {
    id: 'sku.modifiers.item-picker.no-items',
    defaultMessage: 'This menu has no items yet',
  },
  noResults: {
    id: 'sku.modifiers.item-picker.no-results',
    defaultMessage: 'No items match your search',
  },
});
